import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Globals } from 'src/app/service/global';
import { LoginService } from 'src/app/service/login.service';
import { startWith } from 'rxjs/internal/operators/startWith';
import { map } from 'rxjs/internal/operators/map';
import { Observable } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-tuleap-dialog',
  templateUrl: './tuleap-dialog.component.html',
  styleUrls: ['./tuleap-dialog.component.css']
})
export class TuleapDialogComponent implements OnInit {
  private readonly notifier!: NotifierService;
  filteredOptions!: Observable<any>;
  projectJson!: any;
  productJson!: any;
  clientJson!: any;
  taskData: any;
  tuleapForm = new UntypedFormGroup({
    projectName: new UntypedFormControl('', [Validators.required]),
    productName: new UntypedFormControl('', [Validators.required]),
    clientName: new UntypedFormControl('', [Validators.required])
  });
  projectId: any;
  options: any;
  currentProjectId: any;
  tuleapMeetingTitle:string;
  tuleapMeetingDate:string;
  tuleapMeetingId:string;

  constructor(private spinner: NgxSpinnerService, private loginService: LoginService, notifierService: NotifierService, private dialog: MatDialog, private globals: Globals, @Inject(MAT_DIALOG_DATA) data: any, private dialogRef: MatDialogRef<TuleapDialogComponent>) {
    
    this.taskData = data.taskData;
    this.notifier = notifierService;
    this.projectJson = [].concat.apply([], this.globals.globalProjectList);
    
    this.tuleapMeetingTitle = data.tuleapMeetingTitle;
    this.tuleapMeetingDate = data.tuleapMeetingDate;
    this.tuleapMeetingId= data.tuleapMeetingId;
    
  }
 


  ngOnInit(): void {
    var projName = this.tuleapForm.get('projectName');

    if (projName != null) {
      this.filteredOptions = projName.valueChanges.pipe(
        startWith(''),
        map(value => this.filter(value || '')),
      );
    }
  }

  filter(value: any) {
    var desc: String[] = [];
    
    const filterValue = value.toLowerCase();
    this.projectJson.forEach((element: any) => {
      
      desc.push(element.label);
    });
    

    return desc.filter(option => option.toLowerCase().includes(filterValue));
  }

  setProductName(data: any) {
    this.tuleapForm.patchValue({
      productName: data
    });
    
  }

  setClientName(data: any) {
    this.tuleapForm.patchValue({
      clientName: data
    });
  }

  // getProjectId(label:any){
  
  //   this.projectJson.forEach((element:any) => {
  
  //   if(element.label == label){
  //     this.currentProjectId = element.id;
  //   }
  //   });

  // }

  setProjectName(data: any) {
    this.tuleapForm.patchValue({
      projectName: data
    });
    
    this.projectJson.forEach((element: any) => {
      
      if (element.label == data) {
        this.currentProjectId = element.id;
      }
    });
    
    this.projectId = this.currentProjectId;
    this.spinner.show();
    this.loginService.getTuleapTrackersList(this.projectId).subscribe(data => {
      
      if (data.body.Client != null || data.body.Product != null) {
        this.productJson = JSON.parse(data.body.Product);
        this.clientJson = JSON.parse(data.body.Client);
        
      }
      else {
        this.productJson = null;
        this.clientJson = null;
      }
      this.spinner.hide();
    });
  }

  public signUpCheckError = (controlName: string, errorName: string) => {
    return this.tuleapForm.controls[controlName].hasError(errorName)
  }

  closeDialog() {
    this.dialogRef.close(false);
  }

  onSubmit() {
    if (!this.tuleapForm.invalid) {
      this.spinner.show();
      this.tuleapForm.reset();
      //this.dialog.closeAll()
      //var assignedTo:any;
      let assignedTo: string="";
      this.taskData.actionItemOwner.forEach((element: any) => {
        assignedTo += element.fkSecUserOwner+",";
      });
      var plannedStartDate = this.dateConversion(this.taskData.createdOn);
      var plannedEndDate = this.dateConversion(this.taskData.dueDate);
      
      var reqJson = {
        "assignedTo": assignedTo,
        "client": this.tuleapForm.get('clientName')?.value,
        "plannedDuration": "8",
        "plannedEndDate": plannedEndDate,
        "plannedStartDate": plannedStartDate,
        "product": this.tuleapForm.get('productName')?.value,
        "projectId": this.projectId,
        "status": "Open",
        "taskId": this.taskData.taskId,
        "taskTitle": this.taskData.taskTitle,
        "userId": localStorage.getItem("userId"),
        "meetingTitle":this.tuleapMeetingTitle,
        "meetingDate":this.tuleapMeetingDate,
        "meetingId":this.tuleapMeetingId

      }

 
      this.loginService.saveTuleapTask(reqJson).subscribe(data => {
        if(data.body.tuleapId != null) {
          this.notifier.notify("success", "Task added to Tuleap successfully");
        }
        else{
          this.notifier.notify("error","The task was not ingested in Tuleap");
        }
        this.spinner.hide();
        this.dialogRef.close(data);
      });
    }

  }
  dateConversion(dateValue: any) {
    let month = new Date(dateValue).getMonth() + 1
    let date = new Date(dateValue).getDate()
    let year = new Date(dateValue).getFullYear()
    
    var convertedDate = year + '-' + month + '-' + date;
    return convertedDate;
  }

}
